var $3597d722a30a8081$exports = {};
$3597d722a30a8081$exports = {
    "(optional)": `(opcionalno)`,
    "(required)": `(obvezno)`
};


export {$3597d722a30a8081$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
